import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";

export default function StudentTopMenu({
  slug,
  activeMenu}) {
  //const [studentRole, setStudentRole] = useState(0);
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    //setStudentRole(info[0].role);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
   
    //console.log("Student Role",info[0].role);
    
  }

  //console.log("Student Info", isStudent12,isStudent911);



  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
     {isStudent911 && (
      <div className="settings-widget2">
        <div className="settings-inner-blk">
          <div className="sell-course-head">
            <div className="sidebar-tag-labels">
              <ul
                className="list-unstyled justify-content-around p-2"
                style={{ fontSize: "14px" }}
              >
                 <li>
                  <Link
                    to={`/instructor/instructor-studentschedule/${slug}`}
                    className={
                      activeMenu === "Schedule"
                        ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                    }
                  >
                    Schedule
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/instructor/instructor-studenttask/${slug}`}
                    className={
                      activeMenu === "Task"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Task
                  </Link>
                </li>
                  <li>
                    <Link
                      to={`/instructor/instructor-studentgradelist/${slug}`}
                      className={
                        activeMenu === "GradeList"
                          ? "fw-bolder text-decoration-underline  text-center"
                          : "text-center"
                      }
                    >
                      Grades
                    </Link>
                  </li>
                <li>
                  <Link
                    to={`/instructor/instructor-studentactivty/${slug}`}
                    className={
                      activeMenu === "Activity"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Activities
                  </Link>
                </li>
                    <li>
                      <Link
                        to={`/instructor/instructor-studentbooklist/${slug}`}
                        className={
                          activeMenu === "BookList"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        Readings
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/instructor/instructor-studentgoalgrades/${slug}`}
                        className={
                          activeMenu === "GoalGrades"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        Goals
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`/instructor/instructor-studenttranskript/${slug}`}
                        className={
                          activeMenu === "Transkript"
                            ? "fw-bolder text-decoration-underline text-center"
                            : "text-center"
                        }
                      >
                        Transcript
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/instructor/instructor-studentpersonalquestion/${slug}`}
                        className={
                          activeMenu === "PersonalQuestions"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        Career
                      </Link>
                    </li>
                <li>
                  <Link
                    to={`/instructor/instructor-studentnotes/${slug}`}
                    className={
                      activeMenu === "Notes"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Notes
                  </Link>
                </li>
                  <li>
                    <Link
                      to={`/instructor-student-profile/${slug}`}
                      className={
                        activeMenu === "Profile"
                          ? "fw-bolder text-decoration-underline  text-center"
                          : "text-center"
                      }
                    >
                      College Profile
                    </Link>
                  </li>
                  <li>
                  <Link
                    to={`/instructor/instructor-studentresource/${slug}`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                    }
                  >
                    Resources
                  </Link>
                </li>
                <li>
                      <Link
                        to={`/instructor/college-list/${slug}`}
                        className={
                          activeMenu === "CollegeList"
                              ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                        }
                      >
                        College List
                      </Link>
                    </li>
                {/*}
                <li>
                <Link
                    to={`/instructor/instructor-studentsat/${slug}`}
                    className={
                      activeMenu === "Sat"
                        ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                    }
                  >
                    Sat
                  </Link>                
                </li>
                */}
              </ul>
            </div>
          </div>
        </div>
      </div>
     )}
      {isStudent12 && (
      <div className="settings-widget2">
        <div className="settings-inner-blk">
          <div className="sell-course-head">
            <div className="sidebar-tag-labels">
              <ul
                className="list-unstyled justify-content-around p-2"
                style={{ fontSize: "14px" }}
              >
                <li className="bg-info-subtle">
                  <Link
                    to={`/instructor/instructor-studentschedule/${slug}`}
                    className={
                      activeMenu === "Schedule"
                        ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                    }
                  >
                    Schedule
                  </Link>
                </li>
                <li className="bg-info-subtle">
                  <Link
                    to={`/instructor/instructor-studenttask/${slug}`}
                    className={
                      activeMenu === "Task"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Task
                  </Link>
                </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-studentchecklist/${slug}`}
                        className={
                          activeMenu === "CheckList"
                            ? "fw-bolder text-decoration-underline text-center"
                            : "text-center"
                        }
                      >
                        Checklist
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-curriculumtable/${slug}`}
                        className={
                          activeMenu === "Profile"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        App. Timeline
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-studentmainessay/${slug}`}
                        className={
                          activeMenu === "Profile"
                            ? "fw-bolder text-decoration-underline fs-5 text-center"
                            : "text-center"
                        }
                      >
                        Main Essay
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-studentsupplementalessay/${slug}`}
                        className={
                          activeMenu === "SuplementalEssay"
                            ? "fw-bolder text-decoration-underline text-center"
                            : "text-center"
                        }
                      >
                        Supplementals
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-studentadditionalinfo/${slug}`}
                        className={
                          activeMenu === "Profile"
                            ? "fw-bolder text-decoration-underline fs-5 text-center"
                            : "text-center"
                        }
                      >
                        Additional Info
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                  <Link
                    to={`/instructor/instructor-studentactivty/${slug}`}
                    className={
                      activeMenu === "Activity"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Activities
                  </Link>
                </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/instructor-studentbragsheet/${slug}`}
                        className={
                          activeMenu === "Profile"
                            ? "fw-bolder text-decoration-underline fs-5 text-center"
                            : "text-center"
                        }
                      >
                        BragSheet
                      </Link>
                    </li>
               
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor-student-profile_2/${slug}`}
                        className={
                          activeMenu === "Profile_2"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        App. Profile
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                  <Link
                    to={`/instructor/instructor-studentresource/${slug}`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline fs-5 text-center"
                        : "text-center"
                    }
                  >
                    Resources
                  </Link>
                </li>
                    <li className="bg-info-subtle">
                      <Link
                        to={`/instructor/college-list/${slug}`}
                        className={
                          activeMenu === "CollegeList"
                            ? "fw-bolder text-decoration-underline  text-center"
                            : "text-center"
                        }
                      >
                        College List
                      </Link>
                    </li>
                    <li className="bg-info-subtle">
                  <Link
                    to={`/instructor/instructor-studentnotes/${slug}`}
                    className={
                      activeMenu === "Notes"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Notes
                  </Link>
                </li>                
              </ul>
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
}
